import {useContext} from "react";
import {AppContext} from "../../context/AppContext";
import styles from './Header.module.scss';
import Icon from "../elements/Icon/Icon";
import Profile from "./components/Profile/Profile";
import {Link} from "react-router-dom";
import AdminMenu from "./components/AdminMenu/AdminMenu";

const Header = () => {
    const {theme, toggleTheme, isAdmin} = useContext(AppContext);
    const token = sessionStorage.getItem("authTokenData")

    return (
        <header className={styles.header}>
            <Link className={styles.logo} aria-label="Home Page" to={'/'}/>
            <button className={styles.themeToggle} aria-label="Theme toggle" onClick={() => toggleTheme()}>
                <Icon
                    color={theme === 'light' ? 'var(--btn-theme)' : 'var(--btn-theme)'}
                    name={theme === 'light' ? 'moon' : 'sun'}
                    size={20}
                    customStyle={{transition: 'color 350ms ease-in-out'}}
                />
            </button>
            {!!token && isAdmin ? <AdminMenu/> : <Profile/>}
        </header>
    );
};

export default Header;
